import React from 'react';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const blueStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    label: {
        fontSize: '15px'
    },
    icon: {
        borderRadius: '50%',
        width: 30,
        height: 30,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1976D2',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 30,
            height: 30,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
});

export function StyledRadio(props) {
    const classes = blueStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

const likertRadio = makeStyles({
    root: {
        padding: props => props.styles.padding,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: props => props.styles.height,
        height: props => props.styles.height,
        boxShadow: props => props.styles.boxShadow,
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },

    },
    checkedIcon: {
        backgroundColor: props => props.styles.color,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: props => props.styles.height,
            height: props => props.styles.height,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: props => props.styles.color,
        },

    }
});

export function Agree3Radio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '32px' : '40px';
    const color = '#4caf50';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`;
    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({styles});
    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export function Agree2Radio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '28px' : '36px';
    const color = '#4caf50';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`;
    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({ styles });

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}


export function Agree1Radio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '22px' : '32px';
    const color = '#4caf50';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`;
    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({ styles });

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export function NeutralRadio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '20px' : '28px';
    const color = '#aaa';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`;
    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({ styles });

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export function Disagree3Radio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '32px' : '40px';
    const color = '#b22a00';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`

    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({ styles });
 
    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export function Disagree2Radio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '28px' : '36px';
    const color = '#b22a00';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`;
    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({ styles });

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}


export function Disagree1Radio(props) {
    let smMobile = useMediaQuery('(max-width:320px)');
    let mMobile = useMediaQuery('(max-width:360px)');
    let lMobile = useMediaQuery('(max-width:480px)');
    const mobile = smMobile || mMobile || lMobile;
    const padding = mobile ? '5px' : '7px';
    const height = mobile ? '22px' : '32px';
    const color = '#b22a00';
    const boxShadow = `inset 0 0 0 1px ${color}, inset 0 -1px 0 ${color}`;
    const styles = {
        padding,
        height,
        color,
        boxShadow
    };
    const classes = likertRadio({ styles });

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
